import { createSelector } from '@ngrx/store';

import { aiModelsFeature } from './ai-models.feature';

export const selectAiModelsState = aiModelsFeature.selectAiModelsState;
export const selectAiModelsData = createSelector(selectAiModelsState, (s) => s.aiModels);
export const selectAiModelsLoading = aiModelsFeature.selectLoading;
